import type { BehandlingsvalgSammenlikningBlockDto } from '../types/cms';

import Spacer from '@helsenorge/designsystem-react/components/Spacer';

import BehandlingsvalgVelgeBlock from '@helsenorge/core-cms/behandlingsvalg/behandlingsvalgvelgeblock';
import BehandlingsvalgIntroBlock from '@helsenorge/core-cms/behandlingsvalg/introblock';
import RefleksjonsBlock from '@helsenorge/core-cms/behandlingsvalg/refleksjonsblock';
import ImageBlock from '@helsenorge/core-cms/image';
import PortableText from '@helsenorge/core-cms/richtext';
import { CardsPerRow } from '@helsenorge/core-cms/types/entities';
import type { FasteTeksterDto } from '@helsenorge/core-cms/types/entities/cms.v1entities';
import VideoMatrise from '@helsenorge/core-cms/videomatrise';
import type { VimeoSubtitleLanguageCodes } from '@helsenorge/core-cms/videospiller/constants';

import VideoFeatureBlock from '../shared/blocks/VideoBlock/VideoBlock';
import { getRelativePath } from '../shared/url-utils';
import BehandlingsvalgSammenlikningWrapper from '../verktoy/behandlingsvalgsammenlikningwrapper';

export const contentMapper = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  contentBlock: any,
  key: number,
  sammenlikningsBlockArray?: BehandlingsvalgSammenlikningBlockDto[],
  showTreatmentLinks?: boolean,
  fasteTekster?: FasteTeksterDto,
  subtitleLanguageCode?: VimeoSubtitleLanguageCodes
): React.ReactNode => {
  if (contentBlock.type === 'BehandlingsvalgIntroBlock') {
    return (
      <div key={key}>
        <Spacer size={'s'} />
        <BehandlingsvalgIntroBlock
          title={contentBlock.title}
          description={contentBlock.description ?? []}
          icon={contentBlock.icon}
          treatmentUrl={getRelativePath(contentBlock.treatmentLink)}
          treatmentLinkText={`${fasteTekster?.moreAbout} ${contentBlock.title.toLowerCase()}`}
          showTreatmentLinks={showTreatmentLinks}
        />
      </div>
    );
  } else if (contentBlock.type === 'BehandlingsvalgVelgeBlock') {
    return (
      <div key={key}>
        <Spacer size={'s'} />
        <BehandlingsvalgVelgeBlock
          title={contentBlock.title}
          icon={contentBlock.icon}
          advantagesHeader={contentBlock.advantagesHeader}
          advantages={contentBlock.advantages}
          disadvantagesHeader={contentBlock.disadvantagesHeader}
          disadvantages={contentBlock.disadvantages}
          leftChoiceLabel={contentBlock.leftChoiceLabel}
          rightChoiceLabel={contentBlock.rightChoiceLabel}
          showPreferenceSlider={contentBlock.showPreferenceSlider}
          showTreatmentLinks={showTreatmentLinks}
        />
      </div>
    );
  } else if (contentBlock.type === 'BehandlingsvalgSammenlikningWrapper' && fasteTekster) {
    return (
      <div key={key}>
        <Spacer size={'s'} />
        <BehandlingsvalgSammenlikningWrapper
          showComparisonAsTable={contentBlock.ShowComparisonAsTable}
          showTreatmentLinks={contentBlock.showTreatmentLinks}
          sammenlikningsBlockArray={sammenlikningsBlockArray}
          procedureTitle={fasteTekster.procedure}
          benefitsTitle={fasteTekster.benefits}
          disadvantagesTitle={fasteTekster.disadvantages}
          selectionLegend={fasteTekster.selectionLegend}
          cardSelectionTitle={fasteTekster.cardSelection}
          tableSelectionTitle={fasteTekster.tableSelection}
        />
      </div>
    );
  } else if (contentBlock.type === 'RefleksjonBlock') {
    return (
      <div key={key}>
        <RefleksjonsBlock
          question={contentBlock.question}
          leftChoiceLabel={contentBlock.leftChoiceLabel}
          rightChoiceLabel={contentBlock.rightChoiceLabel}
        />
        <Spacer size={'xl'} />
      </div>
    );
  } else if (contentBlock._type === 'TextBlock' || contentBlock._type === 'block') {
    return (
      <div key={key}>
        <PortableText value={contentBlock}></PortableText>
      </div>
    );
  } else if (contentBlock._type === 'VideoBlock') {
    return (
      <div key={key}>
        <Spacer size={'s'} />
        <VideoFeatureBlock {...contentBlock} subtitleLanguageCode={subtitleLanguageCode} />
      </div>
    );
  } else if (contentBlock._type === 'VideoMatriseBlock') {
    return (
      <div key={key}>
        <Spacer size={'s'} />
        <VideoMatrise {...contentBlock} cardsPerRow={CardsPerRow.two} subtitleLanguageCode={subtitleLanguageCode} />
      </div>
    );
  } else if (contentBlock._type === 'ImageBlock') {
    return (
      <div key={key}>
        <Spacer size={'s'} />
        <ImageBlock {...contentBlock} size={'Large'} />
      </div>
    );
  } else if (contentBlock._type) {
    return (
      <div key={key}>
        <Spacer size={'s'} />
        <PortableText value={contentBlock}></PortableText>
      </div>
    );
  }

  return null;
};
